import article1 from "../../assets/news/NeuralIntelimed.png";
import article2 from "../../assets/news/AlemanaIntelimed.png";
import article3 from "../../assets/news/DeepcIntelimedAlemana.png";
import jpr1 from "../../assets/news/JPR1.jpeg";
import jpr2 from "../../assets/news/JPR2.jpeg";

export const newsTranslations = {
  es: {
    news: {
      title: "Noticias y Artículos",
      subtitle: "Mantente informado",
      readArchive: "Ver archivo",
      subscribeTitle: "Suscríbete a nuestro Boletín",
      subscribeSuccess: "¡Suscripción exitosa, gracias!",
      by: "Por",
      posts: [
        {
          id: 4,
          date: "2026-05-05",
          image: jpr1,
          image2: jpr2,
          internal: true,
          title: "Intelimed en el JPR 2026: Parte activa de la radiología latinoamericana",
          summary: "Parte de nuestro equipo estuvo presente en el JPR 2026 en São Paulo — uno de los congresos de radiología más importantes de América Latina, con más de 20.000 participantes y cerca de 100 empresas del sector.",
          readMore: "Leer artículo",
          source: "Intelimed",
          author: "Intelimed",
          article: {
            dateline: "São Paulo, Brasil — Mayo 2026",
            sections: [
              {
                body: [
                  "La Jornada Paulista de Radiologia es uno de los eventos más importantes del sector de la salud en América Latina. Más de 20.000 profesionales, casi 100 empresas del rubro y algunos de los nombres más relevantes de la radiología regional reunidos durante varios días en el Transamerica Expo Center de São Paulo. No es solo un congreso; es un termómetro del estado del arte de la especialidad en la región.",
                  "Esta semana, parte del equipo de Intelimed estuvo ahí.",
                ],
              },
              {
                heading: "Presencia con propósito",
                body: [
                  "Para Intelimed, participar en el JPR 2026 no fue un acto de visibilidad, fue una consecuencia natural de lo que hacemos. Nuestra labor consiste en generar la adopción real de software médico certificado (SaMD) en hospitales, cerrando la brecha entre el momento de la compra y el momento en que esa tecnología funciona de verdad en el flujo clínico del día a día. Ese proceso es complejo, técnico, y profundamente humano.",
                  "Los congresos como el JPR son el lugar donde esa conversación ocurre. Donde los radiólogos, los administradores hospitalarios, los desarrolladores de tecnología y los integradores se encuentran cara a cara, comparten lo que está funcionando y lo que no, y construyen los consensos que luego se traducen en mejores prácticas en toda la región.",
                ],
              },
              {
                heading: "Lo que nos llevamos",
                body: [
                  "Estar en São Paulo nos permitió conectar con actores clave del ecosistema latinoamericano de imagen médica: desde proveedores de soluciones de IA hasta equipos clínicos que están enfrentando exactamente los mismos desafíos de adopción tecnológica que nosotros ayudamos a resolver en Chile. La escala del JPR, y la diversidad de sus participantes, refleja el momento que vive la radiología en la región: más tecnología disponible que nunca, y una necesidad urgente de implementarla bien.",
                  "Esa es exactamente la conversación en la que Intelimed quiere estar.",
                ],
              },
            ],
          },
        },
        {
          id: 1,
          date: "2026-03-24",
          image: article2,
          videoUrl: "https://www.youtube.com/embed/luKPiqcalyY",
          link: "https://youtu.be/luKPiqcalyY",
          title: "Intelimed y Clínica Alemana: El impacto de la IA en Radiología",
          summary: "Descubre cómo el departamento de imágenes de Clínica Alemana integra la IA como un 'compañero experto' para mejorar la detección temprana de patologías y optimizar la atención al paciente.",
          readMore: "Ver video",
          source: "YouTube",
          author: "Intelimed",
        },
        {
          id: 2,
          date: "2026-03-03",
          image: article1,
          link: "https://aiml-innovations.com/press-release/neural-cloud-enters-distribution-agreement-with-intelimed-to-expand-into-latin-america",
          title: "Neural Cloud e Intelimed: Nueva Alianza para expandir la IA en Latam",
          summary: "Neural Cloud entra en un acuerdo de distribución con Intelimed para llevar soluciones avanzadas de IA en salud a instituciones médicas en toda América Latina.",
          readMore: "Leer artículo",
          source: "AIML Innovations",
          author: "AIML Team",
        },
        {
          id: 3,
          date: "2026-02-10",
          image: article3,
          link: "https://www.deepc.ai/news/deepc-continues-to-expand-in-latin-america-ai-powered-radiology-at-clinica-alemana-in-chile",
          title: "deepc se expande en Chile: IA de Vanguardia en Clínica Alemana",
          summary: "A través de Intelimed.ai, Clínica Alemana implementa deepcOS®, permitiendo a los radiólogos acceder a más de 75 soluciones de IA líderes a través de una única integración.",
          readMore: "Leer artículo",
          source: "deepc News",
          author: "deepc Team",
        },
      ],
    },
  },
  en: {
    news: {
      title: "News and Articles",
      subtitle: "Stay informed",
      readArchive: "View archive",
      subscribeTitle: "Subscribe to our Newsletter",
      subscribeSuccess: "Subscription successful, thank you!",
      by: "By",
      posts: [
        {
          id: 4,
          date: "2026-05-05",
          image: jpr1,
          image2: jpr2,
          internal: true,
          title: "Intelimed at JPR 2026: An Active Voice in Latin American Radiology",
          summary: "Part of our team attended JPR 2026 in São Paulo — one of the most important radiology conferences in Latin America, with over 20,000 attendees and nearly 100 industry companies.",
          readMore: "Read article",
          source: "Intelimed",
          author: "Intelimed",
          article: {
            dateline: "São Paulo, Brazil — May 2026",
            sections: [
              {
                body: [
                  "The Jornada Paulista de Radiologia is one of the most significant events in Latin American healthcare. Over 20,000 professionals, nearly 100 industry companies, and some of the most influential names in regional radiology gathered for several days at the Transamerica Expo Center in São Paulo. It is not just a conference, it is a benchmark for where the specialty stands across the region.",
                  "This week, part of the Intelimed team was there.",
                ],
              },
              {
                heading: "Presence with purpose",
                body: [
                  "For Intelimed, attending JPR 2026 was not a visibility exercise, it was a natural extension of what we do. Our work centers on driving the real adoption of certified medical software (SaMD) in hospitals, closing the gap between the moment of purchase and the moment that technology is genuinely embedded in everyday clinical workflows. That process is technical, complex, and deeply human.",
                  "Conferences like JPR are where that conversation happens. Where radiologists, hospital administrators, technology developers, and integrators meet face to face, share what is working and what is not, and build the shared understanding that eventually translates into better practices across the region.",
                ],
              },
              {
                heading: "What we're taking back",
                body: [
                  "Being in São Paulo gave us the opportunity to connect with key players across the Latin American medical imaging ecosystem, from AI solution providers to clinical teams facing the exact same technology adoption challenges we help solve in Chile. The scale of JPR, and the diversity of its attendees, reflects the moment radiology is experiencing in the region: more technology available than ever before, and an urgent need to implement it well.",
                  "That is exactly the conversation Intelimed wants to be part of.",
                ],
              },
            ],
          },
        },
        {
          id: 1,
          date: "2026-03-24",
          image: article2,
          videoUrl: "https://www.youtube.com/embed/luKPiqcalyY",
          link: "https://youtu.be/luKPiqcalyY",
          title: "Intelimed & Clínica Alemana: The Impact of AI in Radiology",
          summary: "Discover how the imaging department at Clínica Alemana integrates AI as an 'expert companion' to enhance early pathology detection and optimize patient care.",
          readMore: "Watch video",
          source: "YouTube",
          author: "Intelimed",
        },
        {
          id: 2,
          date: "2026-03-03",
          image: article1,
          link: "https://aiml-innovations.com/press-release/neural-cloud-enters-distribution-agreement-with-intelimed-to-expand-into-latin-america",
          title: "Neural Cloud & Intelimed: New Partnership to Expand AI in Latam",
          summary: "Neural Cloud enters into a distribution agreement with Intelimed to bring advanced healthcare AI solutions to medical institutions across Latin America.",
          readMore: "Read article",
          source: "AIML Innovations",
          author: "AIML Team",
        },
        {
          id: 3,
          date: "2026-02-10",
          image: article3,
          link: "https://www.deepc.ai/news/deepc-continues-to-expand-in-latin-america-ai-powered-radiology-at-clinica-alemana-in-chile",
          title: "deepc Expands in Chile: Cutting-Edge AI at Clínica Alemana",
          summary: "Through Intelimed.ai, Clínica Alemana implements deepcOS®, allowing radiologists to access over 75 leading AI solutions via a single integration.",
          readMore: "Read article",
          source: "deepc News",
          author: "deepc Team",
        },
      ],
    },
  },
};

